import keycloak from "../Keycloak";
import EventObserver from "../utils/EventObserver";

function setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
}

function deleteToken() {
    localStorage.clear();
    EventObserver.remove('keycloakReady');

    // Build redirect URI without port (for reverse proxy compatibility)
    const redirectUri = `${window.location.protocol}//${window.location.hostname}/fe/`;

    keycloak.logout({ redirectUri });
}

function setToken(token) {
    localStorage.setItem('token', JSON.stringify(token));
}

function getToken() {
    return JSON.parse(localStorage.getItem('token'))
}

function getUser() {
    return JSON.parse(localStorage.getItem('user'));
}

export {
    getUser,
    getToken,
    setUser,
    deleteToken,
    setToken
};
